import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import { ToastProvider } from './components/Toast';
import { ConfirmProvider } from './components/ConfirmDialog';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import QuestionBanks from './pages/QuestionBanks';
import TestSchemas from './pages/TestSchemas';
import CreateTestSchema from './pages/CreateTestSchema';
import TestInvitations from './pages/TestInvitations';
import AllInvitations from './pages/AllInvitations';
import TestResults from './pages/TestResults';
import Instructions from './pages/Instructions';
import Payment from './pages/Payment';
import API from './pages/API';
import Feedback from './pages/Feedback';
import Profile from './pages/Profile';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import PublicOffer from './pages/PublicOffer';
import AdminPanel from './pages/AdminPanel';
import './App.css';

function App() {
  const isAuthenticated = () => localStorage.getItem('token') !== null;
  const PrivateRoute = ({ children }) => (isAuthenticated() ? children : <Navigate to="/login" />);

  return (
    <Router>
      <ToastProvider>
      <ConfirmProvider>
      <div className="App">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

          {/* Authenticated cabinet — Layout stays mounted (no flicker), pages render via <Outlet/> */}
          <Route element={<PrivateRoute><Layout /></PrivateRoute>}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/question-banks" element={<QuestionBanks />} />
            <Route path="/test-schemas" element={<TestSchemas />} />
            <Route path="/test-schemas/create/:bankId" element={<CreateTestSchema />} />
            <Route path="/invitations" element={<AllInvitations />} />
            <Route path="/test-schemas/:id/invitations" element={<TestInvitations />} />
            <Route path="/test-results/:invitationId" element={<TestResults />} />
            <Route path="/instructions" element={<Instructions />} />
            <Route path="/payment" element={<Payment />} />
            <Route path="/api" element={<API />} />
            <Route path="/feedback" element={<Feedback />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/admin" element={<AdminPanel />} />
          </Route>

          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/public-offer" element={<PublicOffer />} />
          <Route path="/" element={<Landing />} />
        </Routes>
      </div>
      </ConfirmProvider>
      </ToastProvider>
    </Router>
  );
}

export default App;
